<template>
  <div class="modal-backdrop">
    <div class="modal-contianer">
      <div class="message">{{ message }}</div>
      <button class="modal-close-btn" @click="$emit('closeModal')">關閉</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "AlertModal",
  props: {
    message: String,
  },
  emits: ["closeModal"],
};
</script>

<style>
.modal-backdrop {
  content: "";
  display: block;
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 9999;
}
.modal-contianer {
  width: 90%;
  max-width: 350px;
  border-radius: 8px;
  background: white;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 10000;
  padding: 30px;
}
.modal-close-btn {
  font-size: 18px;
  background-color: #ec7946;
  color: #fff;
  border-radius: 1em;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.2em 0.8em;
  cursor: pointer;
  border: none;
  box-shadow: none;
  transition: box-shadow 0.8s;
  position: relative;
  margin: 1em auto 0;
  min-width: 100px;
}
.message {
  text-align: center;
  font-size: 18px;
}
</style>
